module.exports = require("./zh-Hans-CN.js");